import React, { useState } from 'react';
import style from './FilterCardBalance.module.css';

const FilterCardBalance = ({ onFilter }) => {
  const [filters, setFilters] = useState({
    fechaInicio: '',
    fechaFin: '',
    soldByAgent: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Limpiar filtros vacíos
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== '')
    );

    // Llamar a la función onFilter con los filtros limpios
    onFilter(cleanedFilters);
  };

  return (
    <form className={style.filterForm} onSubmit={handleSubmit}>
      {/* <div className={style.filterItem}>
        <input
          type="date"
          name="fechaInicio"
          value={filters.fechaInicio}
          onChange={handleChange}
          placeholder="Fecha de Inicio"
        />
      </div>
      <div className={style.filterItem}>
        <input
          type="date"
          name="fechaFin"
          value={filters.fechaFin}
          onChange={handleChange}
          placeholder="Fecha de Fin"
        />
      </div> */}
      <div className={style.filterItem}>
        <select name="soldByAgent" value={filters.soldByAgent} onChange={handleChange}>
          <option value="">Vendido por Agente</option>
          <option value="true">Sí</option>
          <option value="false">No</option>
        </select>
      </div>
      <div className={style.filterItem}>
        <button type="submit" className={`${style.filterButton} ${style.navButton}`}>
          Aplicar Filtros
        </button>
      </div>
    </form>
  );
};

export default FilterCardBalance;